<template>
  <div id="hcp-article">
    <mu-content-block class="contentLoader" v-if="initialLoad">
      <mu-circular-progress :size="48"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <article v-if="!initialLoad" class="content">
      <h1 class="blueTitle" v-html="$sanitize(article.post_title)"></h1>
      <figure class="media" v-if="article.post_format === 'video'">
        <mu-circular-progress class="loader" :size="36"></mu-circular-progress>
        <div v-html="$sanitize(article.post_video_iframe, {allowedAttributes: {
                        'iframe': [ 'width', 'height', 'allow', 'frameborder', 'src', 'webkitallowfullscreen', 'mozallowfullscreen', 'allowfullscreen'] }})"></div>
      </figure>
      <!--<mu-card v-if="article.post_video_desc">
        <mu-card-text>
          <div class="video-caption" v-text="article.post_video_desc"></div>
        </mu-card-text>
      </mu-card>-->
      <mu-row>
        <mu-col width="100" tablet="75" desktop="75">
          <mu-card>
            <mu-card-text>
              <div class="desc" v-html="$sanitize(article.post_content)"></div>
              <mu-raised-button
                id="viewReferencesBtn"
                class="smoothBtn primary"
                :label="toggle.references ? 'Hide References' : 'View References'"
                primary
                v-if="hasReferences"
                @click="toggleReferences()"
              />
              <div class="references" v-show="hasReferences && toggle.references">
                <ol>
                  <li v-for="reference, refIndex in article.post_references" :id="`reference-${refIndex + 1}`" :key="`reference-${refIndex}`" :class="{'active' : activeReference === refIndex + 1 }">
                    <a :href="reference.reference_url" target="_blank" v-text="reference.reference_title"></a>
                  </li>
                </ol>
              </div>
              <div class="further-reading" v-if="hasFurtherReading">
                <h3>Further Reading</h3>
                <ol>
                  <li v-for="further, furtherIndex in article.post_further_reading" :key="`further-${furtherIndex}`">
                    <a :href="further.further_reading_url" target="_blank" v-text="further.further_reading_title"></a>
                  </li>
                </ol>
              </div>
            </mu-card-text>
          </mu-card>
        </mu-col>
        <mu-col width="100" tablet="25" desktop="25">
          <mu-card id="similar" style="padding: 0 20px;">
            <h4>Similar articles</h4>
            <div class="dummy" v-for="dummy, dummyIndex in similar.per_page" v-if="similar.isLoading" :key="`dummy-${dummyIndex}`">
              <mu-linear-progress class="img" :size="15" color="#d9d9d9" />
              <mu-linear-progress class="title" :size="10" color="#d9d9d9" />
              <mu-linear-progress :size="10" color="#d9d9d9" />
            </div>
            <article v-for="article, articleIndex in similar.articles" v-if="!similar.isLoading" :key="`article-${articleIndex}`">
              <figure class="media" v-if="article.post_format === 'video'">
                <mu-circular-progress class="loader" :size="36"></mu-circular-progress>
                <router-link :to="'/hcp/article/' + article.post_slug">
                  <img :src="article.post_video_thumb" />
                </router-link>
              </figure>
              <h3 class="title">
                <router-link :to="'/hcp/article/' + article.post_slug" v-text="article.post_title"></router-link>
              </h3>
              <p class="desc" v-text="article.post_video_desc"></p>
            </article>
          </mu-card>
        </mu-col>
      </mu-row>
    </article>
  </div>
</template>
<script>
  import './Article.less';
  import TitleManager from '../../../helpers/TitleManager';
  import hcpApi from '../../../api/Hcp';
  export default {
    watch: {
      "$route": function() {
        let self = this;
        self.initMounted();
      }
    },
    data() {
      return {
        initialLoad: true,
        article: {},
        activeReference: null,
        toggle: {
          references: false,
        },
        similar: {
          articles: {},
          per_page: 3,
          isLoading: true,
        },
      }
    },
    methods: {
      toggleReferences() {
        let self = this;
        self.toggle.references =! self.toggle.references;
        self.activeReference = null;
      },
      fetchArticle() {
        let self = this;
        self.initialLoad = true;
        self.similar.isLoading = true;
        hcpApi.getModule(self.$route.params.slug).then(response => {
          self.article = response.data;
          self.initialLoad = false;
          TitleManager.setTitle(self.substr(self.article.post_title, 0, 40));
          self.handleReferences();
          self.fetchSimilarArticles();
        }).catch(error => {
          if (error.response.status === 404) {
            self.$router.push({
              name: '404'
            })
          }
        })
      },
      fetchSimilarArticles() {
        let self = this,
            post_id = self.article.post_id;
        hcpApi.getSimilarModules(post_id, self.similar.per_page).then(response => {
          self.similar.isLoading = false;
          self.similar.articles = response.data;
        });
      },
      handleReferences() {
        let self = this;
        $('body').on('click', '.desc sup', function() {
          self.toggle.references = true;
          let text = $(this).text(),
              reference = parseInt(text.replace(/[\[\]']+/g,''));
          self.activeReference = reference;
          setTimeout(() => {
            $('.main-content').scrollTop( $("#reference-" + self.activeReference).offset().top );
          });
        });
      },
      substr(content, start, end) {
        return content.substr(start, end) + '...';
      },
      goToArticle(slug) {
        let self = this;
        self.$route.push({
          name: 'HcpArticle',
          params: {
            slug: slug,
          }
        });
      },
      initMounted() {
        let self = this;
        self.fetchArticle();
      }
    },
    computed: {
      hasReferences() {
        let self = this;
        return self.article.post_references.length !== 0;
      },
      hasFurtherReading() {
        let self = this;
        return self.article.post_further_reading.length !== 0;
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }
</script>



// WEBPACK FOOTER //
// Article.vue?3daef0d2